module.exports = __webpack_public_path__ + "static/media/menu.8968b3b0.svg";